import React, {useEffect, useState} from 'react';
import Pagination from "../components/Pagination";
import {useTranslation} from "react-i18next";
import EmptyState from "../components/EmptyState";
import PlusIcon from "../components/Icons/PlusIcon";
import GpsrDeleteProductModal from "../components/GpsrDeleteProductModal";
import GpsrAllProductsTable from "../components/GpsrAllProductsTable";
import {usePagination} from "../hooks/usePagination";
import {useNavigate} from "react-router-dom";
import ArrowLeftIcon from "../components/Icons/ArrowLeftIcon";
import {getAllProducts, setIsError} from "../store/slices/gpsrProductsSlice";
import {useAppDispatch, useAppSelector} from "../hooks/redux";
import {usePermissions} from "../hooks/usePermissions";
import {addNotification} from "../store/slices/notificationSlice";
import { withLicenseCheck } from '../components/hoc/withLicenseCheck';

const GpsrPage = () => {

    const {t} = useTranslation();
    const {error, isLoading, isError} = useAppSelector(state => state.gpsrProducts);
    const navigate = useNavigate();
    const {items, startItem, endItem, page, totalPages, total, handlePageChange, loading} = usePagination()
    const dispatch = useAppDispatch();
    // Subuser: create / edit / delete products requires gpsr_write.
    const {can} = usePermissions();
    const canWrite = can('gpsr_write');

    const [open, setOpen] = useState<boolean>(false)
    const [productID, setProductID] = useState<string | null>(null)
    const [productName, setProductName] = useState<string>('')

    const openModalHandle = (productId: string, productName: string) => {
        setProductID(null);
        setProductID(productId);
        setProductName(productName);
        setOpen(true);
    }

    useEffect(() => {
        dispatch(getAllProducts())
    }, [dispatch])

    useEffect(() => {
        if (isError) {
            dispatch(addNotification({
                type: "error",
                title: "",
                message: error ? error : "",
            }))

            dispatch(setIsError(false))
        }
    }, [isError, isLoading])

    if (isLoading) return null

    return (
        <>
            <GpsrDeleteProductModal productId={productID} productName={productName} open={open} onClose={() => setOpen(false)} />
            <div className='gpsr-content'>
                <div className='gpsr-content-header-wrapper'>
                    <div className='gpsr-content-header-title'>
                        <button onClick={() => navigate(-1)}>
                            <ArrowLeftIcon />
                        </button>
                        {t('gpsr:products_title')}
                    </div>
                    <div className='gpsr-content-header-btn'>
                        <button
                            className='btn btn-primary'
                            onClick={() => navigate('/features/gpsr/product/add')}
                            disabled={!canWrite}
                            title={!canWrite ? t('subuser_no_permission_tooltip') : undefined}
                        >
                            {t('gpsr:products_btn')} <PlusIcon />
                        </button>
                    </div>
                </div>

                <div className="table-container">
                    {items.length === 0
                        ?
                        <EmptyState
                            title={t('gpsr:products_empty_list_title')}
                            description={t('gpsr:products_empty_list_description')}
                        />
                        :
                        <GpsrAllProductsTable products={items} openModalHandle={openModalHandle} />
                    }
                </div>

                {items.length > 0 &&
                    <Pagination
                        startItem={startItem + 1}
                        endItem={endItem}
                        total={total}
                        totalPages={totalPages}
                        page={page}
                        loading={loading}
                        handlePageChange={handlePageChange}
                    />
                }
            </div>
        </>
    );
};

export default withLicenseCheck(GpsrPage, 'gpsr'); 